import { PaymentGateway } from '@shared/constants/gateway';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GetIconMethodPaymentService {
  public getIconMethodPayment(method: string): string {
    const normalizedMethod = method.toUpperCase() as PaymentGateway;

    switch (normalizedMethod) {
      case PaymentGateway.PAYCOMET_BIZUM:
      case PaymentGateway.MONEI_BIZUM:
      case PaymentGateway.REDSYS_BIZUM:
        return '/assets/icons/payment-methods/bizum-icon.svg';

      case PaymentGateway.PAYCOMET_MULTIBANCO_SIBS:
      case PaymentGateway.PAYCOMET_MBWAY:
        return '/assets/icons/payment-methods/mbway-icon.svg';

      case PaymentGateway.PAYCOMET:
        return '/assets/icons/payment-methods/paycomet-icon.svg';

      case PaymentGateway.STRIPE:
        return '/assets/icons/payment-methods/stripe-icon.svg';

      case PaymentGateway.REDSYS:
        return '/assets/icons/payment-methods/redsys-icon.svg';

      case PaymentGateway.INGENICO:
        return '/assets/icons/payment-methods/ingenico-icon.svg';

      case PaymentGateway.MYMOID:
        return '/assets/icons/payment-methods/mymoid-icon.svg';

      case PaymentGateway.MONETICO:
        return '/assets/icons/payment-methods/monetico-icon.svg';

      case PaymentGateway.INESPAY:
        return '/assets/icons/payment-methods/inespay-icon.svg';

      case PaymentGateway.GREEN_PAY:
        return '/assets/icons/payment-methods/green-pay-icon.svg';

      case PaymentGateway.MONEI:
        return '/assets/icons/payment-methods/monei-icon.svg';

      case PaymentGateway.ADYEN:
        return '/assets/icons/payment-methods/adyen-icon.svg';

      default:
        return '';
    }
  }

  public getFriendlyName(paymentGateway: PaymentGateway): string {
    switch (paymentGateway) {
      case PaymentGateway.GREEN_PAY:
        return 'Green Pay';
      case PaymentGateway.INESPAY:
        return 'InesPay';
      case PaymentGateway.INGENICO:
        return 'Ingenico';
      case PaymentGateway.MONEI:
        return 'Monei';
      case PaymentGateway.MONEI_BIZUM:
        return 'Monei Bizum';
      case PaymentGateway.MONETICO:
        return 'Monetico';
      case PaymentGateway.MYMOID:
        return 'MyMoid';
      case PaymentGateway.PAYCOMET:
        return 'Paycomet';
      case PaymentGateway.PAYCOMET_BIZUM:
        return 'Paycomet Bizum';
      case PaymentGateway.PAYCOMET_MBWAY:
        return 'Paycomet MB Way';
      case PaymentGateway.PAYCOMET_MULTIBANCO_SIBS:
        return 'Paycomet Multibanco SIBS';
      case PaymentGateway.REDSYS:
        return 'Redsys';
      case PaymentGateway.REDSYS_BIZUM:
        return 'Redsys Bizum';
      case PaymentGateway.STRIPE:
        return 'Stripe';
      case PaymentGateway.ADYEN:
        return 'Adyen';
      case PaymentGateway.PAYMEFY:
        return 'Paymefy';
      default:
        return 'Unknown Payment Gateway';
    }
  }
}
